import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import '../src/i18n/i18n';
import './license';
import ErrorBoundary from './errorBoundary';
import { Typography, Stack, Button } from '@mui/material';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { CookiesProvider } from 'react-cookie';

const BLOCK_UI_FOR_MAINTANANCE = false;

if (window.location.hash !== '') {
  console.warn('##Login WLH=', window.location.hash);
  const handleClick = () => {
    localStorage.clear();
    window.location.href = '';
  };

  ReactDOM.render(
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 40,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Something went wrong on our side.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        style={{ marginTop: 16 }}
      >
        Click here to Try again!
      </Button>
    </div>,
    document.getElementById('root'),
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      {BLOCK_UI_FOR_MAINTANANCE ? (
        <div
          style={{
            maxHeight: 250,
            minWidth: 300,
            border: '1px solid orange',
            alignContent: 'center',
            marginTop: 10,
            padding: 10,
          }}
        >
          <Stack alignItems={'center'}>
            <EngineeringIcon
              style={{
                minHeight: 50,
                minWidth: 50,
                color: 'orange',
              }}
            />
            <Typography
              style={{ fontSize: 15, margin: 10, fontWeight: 'bold' }}
            >
              Application is under planned maintanance!
            </Typography>
            <Typography style={{ fontSize: 12, margin: 10 }}>
              Please contact admin/developer for more information.
            </Typography>
          </Stack>
        </div>
      ) : (
        <ErrorBoundary>
          <CookiesProvider>
            <App />
          </CookiesProvider>
        </ErrorBoundary>
      )}
    </React.StrictMode>,
    document.getElementById('root'),
  );
}
reportWebVitals();
